var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":"/","separator-class":"el-icon-arrow-right"}},[_vm._l((_vm.breaditems),function(val,i){return _c('el-breadcrumb-item',{key:i},[_vm._v(_vm._s(val)+" ")])}),_c('el-divider')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }